import { CountryModel } from '@core/data-access';

export class CountryEntity extends CountryModel {}
